import { useTranslation } from 'react-i18next'
import { ClassSelector } from './ClassSelector'
import { ClassConfidenceList } from './ClassConfidenceList'
import { SwitchRow } from './SwitchRow'
import type { DetectorConfigOption, DetectorConfigPatch } from '@/types'

export function DetectorBody({ d, patch, isSuperuser = false }: {
  d: DetectorConfigOption
  patch: (p: DetectorConfigPatch) => void
  isSuperuser?: boolean
}) {
  const { t } = useTranslation('cameras')
  const muted = d.class_override_enabled && d.active_class_ids.length === 0
  const base = d.inherited_confidence ?? 0.25
  const activeSet = new Set(d.active_class_ids)
  const tunable = d.available_classes.filter((c) => activeSet.has(c.class_id))
  return (
    <>
      <p className="text-xs text-muted-foreground">{t('detection.perClassHint')}</p>
      <ClassConfidenceList
        classes={tunable}
        baseDefault={base}
        onCommit={(class_id, conf) =>
          patch({ ai_model_id: d.ai_model_id, class_thresholds: { [String(class_id)]: conf } })}
      />
      {isSuperuser && (
        <>
          <SwitchRow id={`cls-${d.ai_model_id}`} label={t('detection.overrideClasses')}
            checked={d.class_override_enabled}
            onCheckedChange={(on) => patch({ ai_model_id: d.ai_model_id, class_override_enabled: on,
              class_override_ids: on ? d.inherited_class_ids : [] })} />
          {muted && <p className="text-xs text-amber-600 dark:text-amber-500">{t('detection.muteWarning')}</p>}
          {d.class_override_enabled && (
            <ClassSelector available={d.available_classes} activeIds={d.active_class_ids}
              onChange={(ids) => patch({ ai_model_id: d.ai_model_id, class_override_enabled: true,
                class_override_ids: ids })} />
          )}
        </>
      )}
    </>
  )
}
